import {Avatar, Button, Radio} from 'antd'
import {article_getDraftArticlesByUser_Api, article_getPublishedArticlesByUser_Api, auth_channels_Api,} from 'apis'
import {articleModel} from 'apis/model'
import DrawMenu from 'components/drawer/DrawMenu'
import EmptyHolder from 'components/EmptyHolder'
import FeedContext from 'components/Feed/FeedContext'
import {createTimeLineFeed} from 'components/Feed/TimeLineFeed'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import getLinkToDetail from 'helpers/getLinkToDetail'
import _ from 'lodash'
import CustomLazyPaginationWrapper from 'modules/asyncCache/components/CustomLazyPaginationWrapper'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import PermissionContext from 'modules/permissions/PermissionContext'
import React, {useContext, useState} from 'react'
import {IoEllipsisHorizontal} from 'react-icons/io5'
import {RiAddFill} from 'react-icons/ri'
import {Link} from 'react-router-dom'
import ChannelCreatePost from 'views/Channel/components/ChannelCreatePost'
import renderPagingLoading from '../functions/renderPagingLoading'
import {renderIfElse} from "../../Shared";
import getTitle from "../../../helpers/getTitle";
import {getType} from "../../../apis/model/base";
import {BiSolidEdit, BiTrash} from "react-icons/bi";
import {formatRelativeTime} from "../../../helpers/dateUtils";
import {BsPersonFill} from "react-icons/bs";

const ArticleStatus = Object.freeze({
    DRAFT: 'draft',
    PUBLISHED: 'published',
})

const ArticleActions = Object.freeze({
    ADD: 'add',
    EDIT: 'edit',
    DELETE: 'delete',
})

export const MdmArticleContentMeta = () => {
    const {item, created, creatorName, handleClick} = useContext(FeedContext)
    const permissions = useContext(PermissionContext)

    const t = useTranslate()

    const history = useHistory()

    const container = _.get(item, 'container')

    const handleMenuClick = (e) => {
        const {key} = e

        switch (key) {
            case ArticleActions.EDIT:
                history.push({
                    pathname: articleModel.getEditingURL(item),
                })
                break
            default:
                handleClick(key)
        }
    }

    const availbleActions = [
        [BiSolidEdit, ArticleActions.EDIT, 'text-blue-500'],
        [BiTrash, ArticleActions.DELETE, 'text-primary-300'],
    ].filter(([, key]) => permissions[key])

    return (
        <div className="w-full mt-2 mb-3">
            <div className="flex items-center gap-2 mr-10">
                <Avatar
                    size={36}
                    src={_.get(item, 'creator.avatar')}
                    icon={<BsPersonFill className="text-color-400"/>}
                    fallback={<BsPersonFill className="text-color-400"/>}
                    className="flex flex-center background-200"
                />
                {renderIfElse(
                    getType(item?.owner) === "organization",
                    <div className="flex-1 space-x-1">
                        <div className="items-baseline space-x-1 leading-tight">
                            <Link
                                to={getLinkToDetail(item?.owner)}
                                className="font-semibold text-primary no-underline">
                                {getTitle(item?.owner)}
                            </Link>
                            <span
                                className="text-color-400 italic tracking-wider">
                                <label style={{fontStyle: 'normal'}} className="mx-1 font-normal text-color-100">
                                    {formatRelativeTime(created)}
                                </label>
                                {t('on channel')}
                            </span>
                            <Link to={getLinkToDetail(item.container)}
                                  className="font-semibold text-color-100 hover:text-color-000 no-underline">
                                {getTitle(item.container)}
                            </Link>
                        </div>
                    </div>,
                    <div className="flex-1 space-x-1">
                        <div className="items-baseline space-x-1 leading-tight">
                            <span className="font-semibold text-gray-800 capitalize">
                                {t('you')}
                            </span>
                            <span
                                className="text-color-400 italic tracking-wider">
                                <label style={{fontStyle: 'normal'}} className="mx-1 font-normal text-color-100">
                                    {formatRelativeTime(created)}
                                </label>
                                {t('on channel')}
                            </span>
                            <Link to={getLinkToDetail(item.container)}
                                  className="font-semibold text-blue-600 no-underline">
                                {getTitle(item.container)}
                            </Link>
                        </div>
                    </div>,

                )}
            </div>
            {!_.isEmpty(availbleActions) && (
                <DrawMenu
                    menu={
                        {
                            items: availbleActions.map(([Icon, action, color]) => ({
                                key: action,
                                icon: <Icon size={14} className={color} />,
                                label: t(action || ''),
                            })),
                            onClick: (e) => {
                                handleMenuClick(e);
                            },
                        }
                    }
                    component={
                        <Avatar
                            size={28}
                            icon={<IoEllipsisHorizontal size={18} className="text-color-400 hover:text-color-100"/>}
                            className="flex flex-center background hover:background-200 cursor-pointer absolute right-5 top-5 contextIcon"
                        />
                    }>
                </DrawMenu>
            )}
        </div>
    )
}

export const ArticleItemContent = createTimeLineFeed({
    ContentLayout: ({children}) => (
        <div className="p-2 space-y-2 custom-item-render border-t border-color-50 background shadow-md hover:scale-3xs rounded-xl relative">
            {children}
        </div>
    ),
    ContentMeta: MdmArticleContentMeta,
    Footer: () => <div/>,
})

const MyArticles = ({...props}) => {
    const t = useTranslate()

    const history = useHistory()

    const {isSm} = useContext(LayoutContext)

    const [tab, setTabs] = useState(ArticleStatus.DRAFT)

    const apiInfo =
        tab === ArticleStatus.DRAFT
            ? article_getDraftArticlesByUser_Api
            : article_getPublishedArticlesByUser_Api

    const lookupKey = [apiInfo.path, `type=${tab}`].join('/')

    return (
        <div className="flex flex-col gap-3 h-full">
            <div className="flex items-center w-full">
                <div className="flex-1"/>
                <div className="flex items-center gap-3">
                    <ChannelCreatePost
                        apiInfo={auth_channels_Api}
                        linkTo={(item) => {
                            const url = articleModel.getLinkToCreate(item)
                            history.push(url)
                        }}>
                        {(toggle) => (
                            <Button
                                style={{height: 30, padding: '2px 10px', border: 0}}
                                onClick={toggle}
                                type="primary"
                                className="button-rounded-md flex flex-center gap-2 font-semibold text-sm">
                                <RiAddFill size={15}/>
                                {t('create article')}
                            </Button>
                        )}
                    </ChannelCreatePost>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div className="col-span-1 md:col-span-3 flex flex-col gap-4">
                    <div className="flex items-center w-full">
                        <Radio.Group
                            className="discovery-radio-group"
                            optionType="button"
                            buttonStyle="solid"
                            defaultValue={tab}
                            onChange={(e) => {
                                setTabs(e.target.value)
                            }}>
                            <Radio.Button value={ArticleStatus.DRAFT}>
                                {t(ArticleStatus.DRAFT)}
                            </Radio.Button>
                            <Radio.Button value={ArticleStatus.PUBLISHED}>
                                {t(ArticleStatus.PUBLISHED)}
                            </Radio.Button>
                        </Radio.Group>
                    </div>
                    <CustomLazyPaginationWrapper
                        id={lookupKey}
                        key={lookupKey}
                        alwaysVisible={true}
                        apiInfo={apiInfo}
                        renderEmpty={() => <EmptyHolder/>}
                        renderLoading={renderPagingLoading}
                        renderItem={(item, index) => (
                            <ArticleItemContent key={index} item={item}/>
                        )}
                    />
                </div>
            </div>
        </div>
    )
}

export default MyArticles
